import Enum from './Enum.js';
import SupplierId from './enums/SupplierId.js';
import i18n from '../plugins/vue-i18n.js';

export default class CreatedMethods extends Enum {
    static get entries() {
        return {
            activix: 'activix',
            acura_canada: 'acura_canada',
            api: 'api',
            auto_renewal: 'auto_renewal',
            autosync: 'autosync',
            bmw_canada: 'bmw_canada',
            cdk: 'cdk',
            cloning: 'cloning',
            ct_wizard: 'ct_wizard',
            dealer_vu: 'dealer_vu',
            easydeal: 'easydeal',
            f_c_a_digital: 'f_c_a_digital',
            ford_direct: 'ford_direct',
            gm_canada: 'gm_canada',
            honda_canada: 'honda_canada',
            kia_digital: 'kia_digital',
            m_b_c_a_digital: 'm_b_c_a_digital',
            manual: 'manual',
            manual_import: 'manual_import',
            mitsubishi: 'mitsubishi',
            n_c_i_digital: 'n_c_i_digital',
            niotext: 'niotext',
            pbs: 'pbs',
            phone_system: 'phone_system',
            polaris_digital: 'polaris_digital',
            porsche_digital: 'porsche_digital',
            porsche_finder: 'porsche_finder',
            scan: 'scan',
            scraper: 'scraper',
            serti: 'serti',
            stellantis_digital: 'stellantis_digital',
            taq_auto: 'taq_auto',
            messenger: 'messenger',
            harley_davidson_digital: 'harley_davidson_digital',
            polestar: 'polestar',
            maserati_digital: 'maserati_digital',
            prebooking: 'prebooking',
            one_eighty: 'one_eighty',
            hyundai: 'hyundai',
            call_log: 'call_log',
            volkswagen: 'volkswagen',
            reynolds: 'reynolds',
            audi_canada: 'audi_canada',
            jaguar_land_rover_digital: 'jaguar_land_rover_digital',
            bombardier_recreational_products: 'bombardier_recreational_products',
            volvo: 'volvo',
            subaru: 'subaru',
        };
    }

    static get ACTIVIX() {
        return this.entries.activix;
    }

    static get ACURA_CANADA() {
        return this.entries.acura_canada;
    }

    static get API() {
        return this.entries.api;
    }

    static get AUTO_RENEWAL() {
        return this.entries.auto_renewal;
    }

    static get AUTOSYNC() {
        return this.entries.autosync;
    }

    static get BMW_CANADA() {
        return this.entries.bmw_canada;
    }

    static get CDK() {
        return this.entries.cdk;
    }

    static get CLONING() {
        return this.entries.cloning;
    }

    static get CT_WIZARD() {
        return this.entries.ct_wizard;
    }

    static get DEALER_VU() {
        return this.entries.dealer_vu;
    }

    static get EASYDEAL() {
        return this.entries.easydeal;
    }

    static get F_C_A_DIGITAL() {
        return this.entries.f_c_a_digital;
    }

    static get FORD_DIRECT() {
        return this.entries.ford_direct;
    }

    static get GM_CANADA() {
        return this.entries.gm_canada;
    }

    static get HONDA_CANADA() {
        return this.entries.honda_canada;
    }

    static get KIA_DIGITAL() {
        return this.entries.kia_digital;
    }

    static get M_B_C_A_DIGITAL() {
        return this.entries.m_b_c_a_digital;
    }

    static get MANUAL() {
        return this.entries.manual;
    }

    static get MANUAL_IMPORT() {
        return this.entries.manual_import;
    }

    static get MITSUBISHI() {
        return this.entries.mitsubishi;
    }

    static get N_C_I_DIGITAL() {
        return this.entries.n_c_i_digital;
    }

    static get NIOTEXT() {
        return this.entries.niotext;
    }

    static get PBS() {
        return this.entries.pbs;
    }

    static get PHONE_SYSTEM() {
        return this.entries.phone_system;
    }

    static get POLARIS_DIGITAL() {
        return this.entries.polaris_digital;
    }

    static get PORSCHE_DIGITAL() {
        return this.entries.porsche_digital;
    }

    static get PORSCHE_FINDER() {
        return this.entries.porsche_finder;
    }

    static get SCAN() {
        return this.entries.scan;
    }

    static get SCRAPER() {
        return this.entries.scraper;
    }

    static get SERTI() {
        return this.entries.serti;
    }

    static get STELLANTIS_DIGITAL() {
        return this.entries.stellantis_digital;
    }

    static get MESSENGER() {
        return this.entries.messenger;
    }

    static get HARLEY_DAVIDSON_DIGITAL() {
        return this.entries.harley_davidson_digital;
    }

    static get POLESTAR() {
        return this.entries.polestar;
    }

    static get MASERATI_DIGITAL() {
        return this.entries.maserati_digital;
    }

    static get TAQ_AUTO() {
        return this.entries.taq_auto;
    }

    static get ONE_EIGHTY() {
        return this.entries.one_eighty;
    }

    static get HYUNDAI() {
        return this.entries.hyundai;
    }

    static get CALL_LOG() {
        return this.entries.call_log;
    }

    static get VOLKSWAGEN() {
        return this.entries.volkswagen;
    }

    static get REYNOLDS() {
        return this.entries.reynolds;
    }

    static get AUDI_CANADA() {
        return this.entries.audi_canada;
    }

    static get JAGUAR_LAND_ROVER_DIGITAL() {
        return this.entries.jaguar_land_rover_digital;
    }

    static get BOMBARDIER_RECREATIONAL_PRODUCTS() {
        return this.entries.bombardier_recreational_products;
    }

    static get VOLVO() {
        return this.entries.volvo;
    }

    static get SUBARU() {
        return this.entries.subaru;
    }

    static get translationGroup() {
        return 'createdMethods';
    }

    static get createdMethodToSupplierIds() {
        return {
            [this.ACURA_CANADA]: [SupplierId.ACURA_CANADA],
            [this.AUDI_CANADA]: [SupplierId.AUDI_CANADA],
            [this.AUTOSYNC]: [SupplierId.AUTOSYNC],
            [this.BMW_CANADA]: [SupplierId.BMW_CANADA],
            [this.BOMBARDIER_RECREATIONAL_PRODUCTS]: [SupplierId.BOMBARDIER_RECREATIONAL_PRODUCTS],
            [this.CALL_LOG]: [SupplierId.CALL_LOG],
            [this.DEALER_VU]: [SupplierId.DEALER_VU],
            [this.EASYDEAL]: [SupplierId.EASY_DEAL],
            [this.F_C_A_DIGITAL]: [SupplierId.FCA_DIGITAL],
            [this.FORD_DIRECT]: [SupplierId.FORD_DIRECT],
            [this.GM_CANADA]: [SupplierId.GM_CANADA],
            [this.HARLEY_DAVIDSON_DIGITAL]: [SupplierId.HARLEY_DAVIDSON_DIGITAL],
            [this.HONDA_CANADA]: [SupplierId.HONDA_CANADA],
            [this.HYUNDAI]: [SupplierId.HYUNDAI],
            [this.JAGUAR_LAND_ROVER_DIGITAL]: [SupplierId.JAGUAR_LAND_ROVER_DIGITAL],
            [this.KIA_DIGITAL]: [SupplierId.KIA_DIGITAL],
            [this.M_B_C_A_DIGITAL]: [SupplierId.MBCA_DIGITAL],
            [this.MASERATI_DIGITAL]: [SupplierId.MASERATI_DIGITAL],
            [this.MITSUBISHI]: [SupplierId.MITSUBISHI],
            [this.N_C_I_DIGITAL]: [SupplierId.NISSAN_DIGITAL],
            [this.ONE_EIGHTY]: [SupplierId.ONE_EIGHTY],
            [this.PBS]: [SupplierId.PBS, SupplierId.PBS_WORK_ORDER],
            [this.POLARIS_DIGITAL]: [SupplierId.POLARIS_DIGITAL],
            [this.POLESTAR]: [SupplierId.POLESTAR],
            [this.PORSCHE_DIGITAL]: [SupplierId.PORSCHE_DIGITAL],
            [this.PORSCHE_FINDER]: [SupplierId.PORSCHE_DIGITAL],
            [this.STELLANTIS_DIGITAL]: [SupplierId.STELLANTIS_DIGITAL],
            [this.SUBARU]: [SupplierId.SUBARU],
            [this.VOLKSWAGEN]: [SupplierId.VOLKSWAGEN],
            [this.VOLVO]: [SupplierId.VOLVO],
        };
    }

    static get createdMethodToAccountFlag() {
        return {
            [this.NIOTEXT]: 'niotext',
            [this.PHONE_SYSTEM]: 'phone_up',
            [this.SCAN]: 'scan',
        };
    }

    static selectOptions(account) {
        return this.values
            .map((value) => {
                const accountFlag = this.createdMethodToAccountFlag[value];
                const supplierIds = this.createdMethodToSupplierIds[value];

                let invalid = false;

                if (accountFlag) {
                    invalid = !account[accountFlag];
                } else if (supplierIds) {
                    invalid = !account.suppliers.some((s) => supplierIds.includes(s.id));
                }

                return {
                    id: value,
                    label:
                        value === this.NIOTEXT && account?.sms_module
                            ? i18n.t('createdMethods.sms')
                            : this.getTranslation(value),
                    invalid,
                };
            })
            .sort((a, b) => a.label.localeCompare(b.label));
    }
}
